/**
 * MCP (Model Context Protocol) configuration templates for various AI coding tools
 */

export const mcpTemplates = {
    CLAUDE_DESKTOP: {
        name: "Claude Desktop / claude.ai",
        get: () => `Settings → Connectors → Add custom connector

Name: ScrapingAnt
URL:  https://api.scrapingant.com/mcp

Click Add, then Connect, and approve the request in this dashboard.`,
        prism_language: "yaml",
        instructions: "Remote servers are added as connectors, not in claude_desktop_config.json. You sign in with your ScrapingAnt account; no API key is needed."
    },
    VSCODE: {
        name: "VS Code / Copilot",
        get: (api_key) => `{
  "servers": {
    "scrapingant": {
      "type": "http",
      "url": "https://api.scrapingant.com/mcp",
      "headers": {
        "x-api-key": "${api_key}"
      }
    }
  }
}`,
        prism_language: "json",
        instructions: "Create .vscode/mcp.json in your workspace or add the server to your VS Code settings. Remove the headers block to sign in with your ScrapingAnt account instead."
    },
    CURSOR: {
        name: "Cursor",
        get: (api_key) => `Name: scrapingant
URL: https://api.scrapingant.com/mcp
Transport: streamableHttp
Headers: x-api-key: ${api_key}`,
        prism_language: "yaml",
        instructions: "Open Settings → MCP → Add new MCP Server and enter the configuration above"
    },
    CLAUDE_CODE: {
        name: "Claude Code",
        get: (api_key) => `# Sign in with your ScrapingAnt account: run this, then type /mcp in Claude Code and choose Authenticate
claude mcp add --transport http scrapingant https://api.scrapingant.com/mcp

# Or authenticate with your API key
claude mcp add --transport http scrapingant https://api.scrapingant.com/mcp -H "x-api-key: ${api_key}"`,
        prism_language: "bash",
        instructions: "Run one of the commands in your terminal to add the ScrapingAnt MCP server"
    },
    CLINE: {
        name: "Cline",
        get: (api_key) => `{
  "mcpServers": {
    "scrapingant": {
      "url": "https://api.scrapingant.com/mcp",
      "transport": "streamableHttp",
      "headers": {
        "x-api-key": "${api_key}"
      }
    }
  }
}`,
        prism_language: "json",
        instructions: "Add to your cline_mcp_settings.json configuration file"
    },
    WINDSURF: {
        name: "Windsurf",
        get: (api_key) => `{
  "mcpServers": {
    "scrapingant": {
      "url": "https://api.scrapingant.com/mcp",
      "transport": "streamableHttp",
      "headers": {
        "x-api-key": "${api_key}"
      }
    }
  }
}`,
        prism_language: "json",
        instructions: "Follow the Windsurf MCP documentation at docs.codeium.com/windsurf/mcp"
    },
    OTHER: {
        name: "Other",
        get: (api_key) => `Server URL: https://api.scrapingant.com/mcp
Transport: streamableHttp
Authentication: OAuth (sign in with your ScrapingAnt account) or the header below
API Key Header: x-api-key: ${api_key}

Generic JSON configuration:
{
  "mcpServers": {
    "scrapingant": {
      "url": "https://api.scrapingant.com/mcp",
      "transport": "streamableHttp",
      "headers": {
        "x-api-key": "${api_key}"
      }
    }
  }
}`,
        prism_language: "yaml",
        instructions: "Use the URL, transport type, and API key header above to configure any MCP-compatible software"
    }
};

export default mcpTemplates;
